export const PLAN_CREATION_STEPS = Object.freeze({
  pricingAndProducts: 0,
  settings: 1,
  completed: 2,
} satisfies Record<string, number>);

export type PlanCreationStep = typeof PLAN_CREATION_STEPS[keyof typeof PLAN_CREATION_STEPS];